<template>
	<div class="">
		<div class="row">
			<div class="col-md-12">
				<div class="row" v-if="false">
					<div class="col-md-12">
						<h5>PL UNIT {{ this.monthname }} {{ this.year }}</h5>
					</div>
				</div>
				<hr class="p-0 m-0" v-if="false">

				<div class="row" v-if="false">
					<div class="col-md-12">
						<el-form  class="mt-2 demo-dynamic" label-position="top" label-width="100px" :inline="true">
						
							<el-form-item label="">
								<el-select v-model="year" filterable placeholder="Select Year" size="medium">
									<el-option v-for="item3 in options.years" :key="item3.value" :label="item3.name" :value="item3.value">
									</el-option>
								</el-select>
							</el-form-item>
						
							<el-form-item label="">
								<el-select v-model="month" filterable placeholder="Select Month" size="medium">
									<el-option v-for="item3 in options.months" :key="item3.value" :label="item3.name" :value="item3.value">
									</el-option>
								</el-select>
							</el-form-item>

						</el-form>
					</div>
				</div>

				<div class="row mt-0">
					<div class="col-md-3 mb-4">
						<ChartView :title="'Laba Bersih'" :charttypedefault="'linechart'" :year="year" :month="month" :area="salesarea" :plant="plant" :unitids="unitids" :costcenters="costcenters"/>
					</div>

					<div class="col-md-3 mb-4">
						<PiechartRevenueFuelNonFuel :title="'Revenue Fuel Non Fuel'" :charttypedefault="'linechart'" :year="year" :month="month" :area="salesarea" :plant="plant" :costcenters="costcenters"/>
					</div>

					<div class="col-md-3 mb-4">
						<PiechartVolumePerProduk :title="'Volume Per Produk'" :charttypedefault="'linechart'" :year="year" :month="month" :area="salesarea" :plant="plant" :fuelcostcenters="fuelcostcenters"/>
					</div>

					<div class="col-md-3 mb-4">
						<PiechartRevenueNonFuel :title="'Revenue Non Fuel'" :charttypedefault="'linechart'" :year="year" :month="month" :area="salesarea" :plant="plant" :nonfuelcostcenters="nonfuelcostcenters"/>
					</div>
				</div>

				<div class="row">
					<div class="col-md-3 mb-4" v-if="false">
						<ChartLabaRugiPerSalesArea :title="'Laba Bersih Per SA'" :charttypedefault="'barchart'" :year="year" :month="month" :area="salesarea" :plant="plant"/>
					</div>

					<div class="col-md-3 mb-4" v-if="false">
						<LineChartFuelNonFuelSalesArea :title="'Sales Fuel & Non Fuel SA'" :charttypedefault="'linechart'" :year="year" :month="month" :area="salesarea" :plant="plant"/>
					</div>

					<div class="col-md-3 mb-4">
						<ChartLosses :title="'LOSSES ' + year" :charttypedefault="'barchart'" :year="year" :month="month" :area="salesarea" :plant="plant" :costcenters="costcenters" :showchartplunit="showchartplunit"/>
					</div>

					<div class="col-md-3 mb-4">
						<ChartVolume :title="'VOLUME ' + year" :charttypedefault="'barchart'" :year="year" :month="month" :area="salesarea" :plant="plant" :fuelcostcenters="fuelcostcenters" :showchartplunit="showchartplunit"/>
					</div>

					<div class="col-md-3 mb-4">
						<PiechartOperatingExpense :title="'Operating Expenses'" :charttypedefault="'piechart'" :year="year" :month="month" :area="salesarea" :plant="plant" :costcenters="costcenters"/>
					</div>
				</div>

			</div>
		</div>
	</div>
</template>

<script>
import Fuel from '@/components/page/Fuel.js'
import { Rainbow, Rainbow3, Penanggalan, AppColors, Config, AxiosWithJar } from '@/utility.js'

import Footer from '@/views/Footer.vue'
import PieChart from '@/components/chart/Pie.js'
import DOOutstandingAllStatusByArea from '@/views/pages/Fuel/DOOutstanding/Component/DOOutstandingAllStatusByArea.vue'
import PiechartOutstandingCardview from '@/views/pages/Fuel/DOOutstanding/Component/PiechartOutstandingCardview.vue'
import DOOutstandingAllDeliveredStatusByArea from '@/views/pages/Fuel/DOOutstanding/Component/DOOutstandingAllDeliveredStatusByArea.vue'

import ChartView from '@/views/pages/Finance/PLUnit/Component/ChartView.vue'
import ChartLabaRugiPerSalesArea from '@/views/pages/Finance/PLUnit/Component/ChartLabaRugiPerSalesArea.vue'
import ChartLosses from '@/views/pages/Finance/PLUnit/Component/ChartLosses.vue'
import ChartVolume from '@/views/pages/Finance/PLUnit/Component/ChartVolume.vue'

import PiechartRevenueFuelNonFuel from '@/views/pages/Finance/PLUnit/Component/PiechartRevenueFuelNonFuel.vue'
import PiechartVolumePerProduk from '@/views/pages/Finance/PLUnit/Component/PiechartVolumePerProduk.vue'
import PiechartOperatingExpense from '@/views/pages/Finance/PLUnit/Component/PiechartOperatingExpense.vue'
import PiechartRevenueNonFuel from '@/views/pages/Finance/PLUnit/Component/PiechartRevenueNonFuel.vue'

import LineChartFuelNonFuelSalesArea from '@/views/pages/Finance/PLUnit/Component/LineChartFuelNonFuelSalesArea.vue'

export default{
	extends: Fuel,
	components:{
		//PiechartOutstandingCardview,
		//DOOutstandingAllStatusByArea,
		//DOOutstandingAllDeliveredStatusByArea,
		//PieChart,
		ChartView,
		PiechartRevenueFuelNonFuel,
		PiechartVolumePerProduk,
		PiechartOperatingExpense,
		PiechartRevenueNonFuel,

		ChartLabaRugiPerSalesArea,
		ChartLosses,
		ChartVolume,

		LineChartFuelNonFuelSalesArea,
          
	},
	props: {
        plant: {
            type: String,
            default: '',
            //required: false,
        },
		costcenters: {
            type: Array,
            default() {
                return [];
            }
        },
        fuelcostcenters: {
            type: Array,
            default() {
                return [];
            }
            //default: () => [],
            //required: false,
        },
		nonfuelcostcenters: {
            type: Array,
            default() {
                return [];
            }
        },
		unitids: {
            type: Array,
            default() {
                return [];
            }
        },
        year: {
            type: Number,
            default: Penanggalan().tahun,
            //required: false,
        },
        month: {
            type: Number,
            default: 0,
            //required: false,
        },
		showchartplunit: {
			type: Boolean,
			default: false,
		}
    },
	data() {
		return {
            value: 0,
			isChildRoute: false,
			areatitle : '',
			monthname : '',

			salesarea: '',
			//month: '', //Penanggalan().bulan,
            //year: Penanggalan().tahun,

			options: {
                months:[
                    {value:'', name: 'All/Ytd'},
                    {value:1, name: 'Januari'},
                    {value:2, name: 'Februari'},
                    {value:3, name: 'Maret'},
                    {value:4, name: 'April'},
                    {value:5, name: 'Mei'},
                    {value:6, name: 'Juni'},
                    {value:7, name: 'Juli'},
                    {value:8, name: 'Agustus'},
                    {value:9, name: 'September'},
                    {value:10, name: 'Oktober'},
                    {value:11, name: 'November'},
                    {value:12, name: 'Desember'},
                ],
                years:[
                    {value:'2021', name: '2021'},
                    {value:'2022', name: '2022'},
                    {value:'2023', name: '2023'},
                    {value:'2024', name: '2024'},
                    {value:'2025', name: '2025'},
                ],
            },

			loading: {
				table : false,
			}
            
		}
	},
	watch: {
		$route(to, from) {
            this.hideNonChildren();
        },

		salesarea() {
			if(this.salesarea == '')
				this.areatitle = 'KONSOL';
			else
				this.areatitle = this.salesarea.toString().toUpperCase();
		},
		month() {
			if(this.month == '')
				this.monthname = 'YTD';
			else
				this.monthname = this.getShortMonthName(this.month).toString().toUpperCase();
		},
        showchartplunit() {
            //console.log('show chart losses PL Unit: ' + this.showchartplunit);
        },
	}, 
	computed: {

	},

    mounted() {
        this.$emit('childrenRoute');
		//this.hideNonChildren();
    },
    methods:{
		
	}
}
</script>


<style>

</style>